export default {"src":"/_next/static/media/whatsapp.fb36f698.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};